<template>
  <div class="box">
    <div class="header">
      <div class="content top-header">
        <div class="verticalMiddle">
          欢迎<span
            style="
              color: #f89a00;
              margin: 0 8px;
              cursor: pointer;
              max-width: 192px;
              overflow: hidden;
            "
            @click="$router.push('/personal')"
            v-if="userName"
            >{{ name }}</span
          >来到鲜丰汇&nbsp;&nbsp;&nbsp;&nbsp;好物助农 即刻出发！
          <span
            style="color: #f89a00; margin-left: 25px; cursor: pointer"
            @click="userName ? logout() : $router.push('/login')"
            >{{ userName ? "退出" : "登录" }}</span
          >
          <!-- <span
            v-if="!userName"
            style="color: #F89A00; margin-left: 15px; cursor: pointer"
            @click="$router.push('/register')"
            >注册</span
          > -->
        </div>
        <div id="nav">
          <span @click="$router.push('/personal')">采购人中心</span>
          <!-- <span>供应商中心</span> -->
          <span class="smallHover"
            >小程序码<span class="smallImgBox"
              ><img
                src="../../../static/image/smallCode.jpg"
                alt=""
                width="100%"
                height="100%"
                class="smallImg" /></span
          ></span>
          <span @click="$router.push('/shopCar')"
            >购物车({{ shopCarNum }})</span
          >
          <span @click="$router.push('/myCollection')"
            >收藏夹({{ collectNum }})</span
          >

          <span @click="$router.push('/infoCenter')">资讯中心</span>
          <span @click="visible = true" style="color: #f89a00"
            >区域专属客户经理</span
          >
          <!-- <span style="color: #f89a00; margin-left: 25px"
            >如有疑问请联系区域客服经理</span
          > -->
        </div>
      </div>
    </div>
    <div class="content search">
      <div class="logo" @click="$router.push('/index')">
        <img src="/static/image/newLogo.png" />
        <div class="line"></div>
        <div class="logo-des">
          <p>消费帮促</p>
          <p>采购平台</p>
        </div>
        <div class="title">{{ title }}</div>
      </div>
      <div class="search-box">
        <div>
          <img
            src="../../../static/image/search.svg"
            alt=""
            class="search-icon"
          />
          <input
            class="search-input"
            type="text"
            placeholder="请输入关键字"
            v-model="title"
            @keyup.enter="search()"
          />
          <button
            type="button"
            id="test"
            class="search-button"
            @click="search()"
          >
            搜索
          </button>
        </div>
      </div>
    </div>
    <Dialog :dialogVisible="visible" @closepop="visible = false"></Dialog>
  </div>
</template>
<script>
import { doPost, doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "./dialog.vue";
export default {
  components: {
    Dialog: dialog,
  },
  props: {
    title: {
      type: String, //可指定接收类型，如:Array.
      default: "", //可设置默认值
      title: "", //搜索关键字
    },
  },
  data() {
    return {
      visible: false,

      userName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      name: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
      shopCarNum: this.$store.state.shopCarNum, //购物车数量
      collectNum: this.$store.state.collectNum, //收藏夹数量
    };
  },
  watch: {
    "$store.state.shopCarNum"() {
      this.shopCarNum = this.$store.state.shopCarNum;
    },
    "$store.state.collectNum"() {
      this.collectNum = this.$store.state.collectNum;
    },
  },
  mounted() {
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
  },
  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { type },
        function (res) {
          if (res.flag) {
            if (type == 0) {
              that.shopCarNum = 0;
              var shopCar = res.data;
              shopCar.forEach((item) => {
                item.info = JSON.parse(item.info);
                that.shopCarNum += item.info.num; //计算购物车商品总数
              });
            } else {
              that.collectNum = res.data.length;
            }
          }
        },
        function (res) {}
      );
    },
    //搜索
    search() {
      if (this.title.length == 0) {
        this.$router.push({ path: "/category" });
      } else {
        this.$router.push({ path: "/category", query: { title: this.title } });
      }
    },
    //退出登录
    logout() {
      var that = this;
      this.$confirm("确认退出登录？")
        .then((_) => {
          that.$cookies.remove("peopleId");
          // that.$cookies.remove("shopCar");
          // that.$cookies.remove("shopAddress");
          // that.$cookies.remove("collectList");
          that.$cookies.remove("userInfo");
          localStorage.removeItem("xfh_usertoken");
          // sessionStorage.clear();
          location.reload();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-bottom: 2px solid #f89a00;
}

.header {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
}
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.smallHover {
  position: relative;
}
.smallHover:hover .smallImgBox {
  display: inline-block;
}
.smallImgBox {
  display: none;
  width: 200px;
  height: 200px;
  position: absolute;
  top: 40px;
  background-color: #fff;
  z-index: 100;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
.smallImgBox::before {
  content: "";
  width: 16px;
  height: 10px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid #fff;
  box-sizing: border-box;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: translate(-50%, 0);
}
.content {
  width: 1200px;
}
.verticalMiddle {
  margin: auto 0;
}
#nav {
  display: flex;
  height: 100%;
}

#nav > span {
  padding: 0 15px;
  cursor: pointer;
  line-height: 40px;
}

.search {
  margin: 36px 0 17px;
  display: flex;
  justify-content: space-between;
}
.logo {
  display: flex;
  align-items: center;
  /* margin-left: 20px; */
  cursor: pointer;
}

.logo img {
  width: 161px;
  height: 64px;
  margin-right: 17px;
}
.line {
  width: 2px;
  height: 39px;
  background-color: #1a7c3d;
}
.logo .logo-des {
  /* margin-left: 12px; */
  margin-left: 17px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo p {
  /* width: 80px; */
  /* height: 20px;
  font-size: 15px;
  font-family: PingFang, PingFang-Bold;
  font-weight: 700;
  color: #07811f;
  letter-spacing: 4px;
  margin: 0; */
  line-height: 28px;
  color: #1a7c3d;
  margin: 0;
  font-size: 22px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
}

.logo p:last-child {
  margin-top: 6px;
}
.title {
  height: 100%;
  display: flex;
  align-items: flex-end;
  font-size: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  font-weight: 700;
  color: #333333;
  margin-left: 49px;
}
.search-box {
  display: flex;
  align-items: center;
}

.search-box div {
  position: relative;
}

.search-box .search-input {
  width: 419px;
  height: 40px;
  border: 3px solid #f89a00;
  border-radius: 10px;
  padding-left: 60px;
  outline: none;
  box-sizing: border-box;
}

.search-box .search-button {
  width: 100px;
  height: 40px;
  background-color: #f89a00;
  color: white;
  border: 0;
  position: absolute;
  right: 0;
  top: 0px;
  border-radius: 0 10px 10px 0;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  letter-spacing: 3px;
  cursor: pointer;
}
.search-box .search-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 17px;
  top: 50%;
  transform: translate(0, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/common/header3.vue